import { CART_LINE_COUNT } from '@data/constants';
import {
	cartFragment,
	imageFragment,
	moneyFragment,
	productOptionFragment,
} from '@data/shopify/fragments';
import { shopifyClient } from '@data/shopify/shopifyClient';
import {
	ShopifyCartLineInput,
	ShopifyCartLinesUpdateResponse,
} from '@interfaces';

export const cartLinesUpdate = async (
	cartId: string,
	lines: ShopifyCartLineInput[],
) => {
	return shopifyClient.request<ShopifyCartLinesUpdateResponse>(
		`
			mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!, $lineCount: Int!) {
				cartLinesUpdate(cartId: $cartId, lines: $lines) {
					cart {
						...Cart
					}
				}
			}
			${cartFragment}
			${imageFragment}
			${moneyFragment}
			${productOptionFragment}
		`,
		{
			cartId,
			lines,
			lineCount: CART_LINE_COUNT,
		},
	);
};
